import React from 'react';

import * as S from './styles';
import { Product } from 'types/Product';
import { CiHeart } from 'react-icons/ci';
import { shrinkText, formatCurrency } from 'utils/functions';
import { png } from 'utils/imgList';

interface FashionProps {
	product: Product;
	isHeartInFashion: boolean;
}

export default function Fashion({ product, isHeartInFashion }: FashionProps) {
	return (
		<S.container>
			<S.photo>
				<img
					src={
						product?.items?.[0]?.images[0]?.imageUrl
							? product?.items?.[0]?.images[0]?.imageUrl
							: png.noImg
					}
					alt={product.productName}
				/>
				{isHeartInFashion && (
					<S.like>
						<CiHeart />
					</S.like>
				)}
			</S.photo>

			<S.infos>
				<S.title>
					<b> {shrinkText(product.productName, 35)}</b>
				</S.title>

				<S.price>
					{formatCurrency(
						product?.items?.[0]?.sellers?.[0]?.commertialOffer?.Price || 0
					)}
				</S.price>
			</S.infos>
		</S.container>
	);
}
